import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as auth from '@webapp/sdk/auth';
import { push } from 'connected-react-router';

window['auth'] = auth;

export const redirectAfterSuccessEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, actionCreators.CreateAdditionalAccountSuccess>(
      actions.CREATE_ADDITIONAL_ACCOUNT_SUCCESS
    ),
    mergeMap(async () => {
      await auth.getUser(true);
      return push('/user/general');
    })
  );
